export default __webpack_public_path__ + "static/media/loginBackgroundAlt.35bc18d8.jpeg";